<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3d0IZW/tc-custom/9781453234488.jpg?1737686691132" alt="This image is the cover for the book All Creatures Great and Small, All Creatures Great and Small"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All Creatures Great and Small, All Creatures Great and Small
      </h1>
      <p class="bookDescription body article font2">
        <b>From a Yorkshire veterinarian and a “wise and wonderful writer”: The <i>New York Times</i> bestseller and basis for the beloved BBC series of the same name (<i>The Boston Globe</i>).</b><br/>  In the rolling dales of Yorkshire, a simple, rural region of northern England, a young veterinarian from Sunderland joins a new practice. A stranger in a strange land, he must quickly learn the odd dialect and humorous ways of the locals, master outdated equipment, and do his best to mend, treat, and heal pets and livestock alike. This witty and heartwarming collection, based on the author’s own experiences, became an international success, spawning sequels and winning over animal lovers everywhere. Perhaps better than any other writer, James Herriot reveals the ties that bind us to the creatures in our lives.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Herriot
      </h2>
      
      <p class="authorDescription body article">James Herriot (1916&ndash;1995) was the pen name of James Alfred &ldquo;Alf&rdquo; Wight, an English veterinarian whose tales of veterinary practice and country life have delighted generations. Many of Herriot&rsquo;s works&mdash;including&#160;<I>All Creatures Great and Small</I>,&#160;<I>All Things Bright and Beautiful</I>,&#160;<I>All Things Wise and Wonderful</I>,&#160;<I>The Lord God Made Them All</I>, and&#160;<I>Every Living Thing</I>&mdash;became international bestsellers and have been adapted for film and television. Herriot&rsquo;s stories rely on numerous autobiographical elements taken from his life in northern England&rsquo;s Yorkshire County, and they depict a simple, rustic world deeply in touch with the cycles of nature.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?216ccfa5